import  Authi18n  from "./authi18n";

const ru: Authi18n = {
  namespace: "core/modules/auth",
  sign: "Войти",
  getData: "Получить данные",
  askAccount: "Нет аккаунта?",
  signUp: "Нажми сюда!",
  rememberMe: "Запомнить меня",
  forgotPassword: "Забыли пароль?",
  password: "Пароль",
  username: "Логин",
  firstName: "Имя",
  secondName: "Фамилия",
  partialName: "Отчество",
  confirmPassword: "Повторите пароль",
  post: "Должность",
  email: "Электронная почта",
  role: "Роли",
  notValidData: "Логин или пароль не верны",
  usernameOrMail: "Логин или электронная почта",
  company: "Организация:",
  phone: "Телефон",
  inputUsernameOrMail: "Введите логин или электронную почту",
  inputPassword: "Введите пароль",
  validate:{
    empty: "Обязательно для заполнения"
  }
};

export default ru;
